import {
  Search, UserRound, Heart, ShoppingBag, Truck, CalendarCheck,
  PackageCheck, Ruler, Armchair, House, ClipboardList, Tag,
  MessageSquareQuote, Undo2,
  type LucideIcon, type LucideProps,
} from "lucide-react";

// One shared interface keeps existing controls and editorial labels unchanged.
function icon(name: string, Symbol: LucideIcon) {
  return function BrandIcon(props: LucideProps) {
    return (
      <Symbol
        size={24}
        strokeWidth={1.75}
        aria-hidden="true"
        focusable="false"
        data-brand-icon={name}
        {...props}
      />
    );
  };
}

export const BrandSearch = icon("search", Search);
export const BrandAccount = icon("account", UserRound);
export const BrandHeart = icon("wishlist", Heart);
export const BrandBag = icon("shopping-bag", ShoppingBag);
export const BrandDelivery = icon("delivery", Truck);
export const BrandDeliveryWindow = icon("delivery-window", CalendarCheck);
export const BrandProtectedParcel = icon("protected-parcel", PackageCheck);
export const BrandRoomPlan = icon("room-plan", Ruler);
export const BrandChair = icon("lounge-chair", Armchair);
export const BrandRoomLove = icon("room-love", House);
export const BrandProductFacts = icon("product-facts", ClipboardList);
export const BrandPrice = icon("price-tag", Tag);
export const BrandReview = icon("real-review", MessageSquareQuote);
export const BrandReturn = icon("returns", Undo2);